import {lazy, Suspense} from 'react'
import {Routes, Route, useNavigate} from 'react-router-dom'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
`

const Board = styled.div`
  display: flex;
  flex: 1;
`

const Index = () => {
  const List = lazy(() => import('./List'))
  const View = lazy(() => import('./View'))

  return (
    <Container>
      <Board>
        <Suspense fallback={''}>
          <Routes>
            {['/', '/:pageNum'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<List/>}
              />
            ))}

            {['/view', '/view/:id'].map((path, index) => (
              <Route
                key={index}
                path={path}
                element={<View/>}
              />
            ))}
          </Routes>
        </Suspense>
      </Board>
    </Container>
  )
}

export default Index
